import { render, staticRenderFns } from "./feeds.vue?vue&type=template&id=34d0405a"
import script from "./feeds.vue?vue&type=script&lang=js"
export * from "./feeds.vue?vue&type=script&lang=js"
import style0 from "./feeds.vue?vue&type=style&index=0&id=34d0405a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports